/** The launch URL's `wheel` (the wheel's part id) — digits only, else none. */
export function parseWheelIdParam(value: string | null): number | null {
  if (value == null || !/^[1-9]\d{0,9}$/.test(value)) return null
  return Number(value)
}
